module.exports = __webpack_public_path__ + "static/media/autoplease.90fa8d4a.webp";